import "../Shop/shop.css"
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


const Shop = () => {
    const [currencies, setCurrencies] = useState([])

    const navigate = useNavigate();

    useEffect(() => {
        
        getCurrencies();
    }, [])

    const shopItems1 = [
        {
            name: "1.1",
            cost: 1000,
        },
        {
            name: "1.2",
            cost: 300,
        },
        {
            name: "1.3",
            cost: 100,
        },
    ]

    const shopItems2 = [
        {
            name: "2.1",
            cost: 200,
        },
        {
            name: "2.2",
            cost: 500,
        },
    ]
    const shopItems3 = [
        {
            name: "2.1",
            cost: 200,
        },
        {
            name: "2.2",
            cost: 500,
        },
    ]

    const getCurrencies = async () => {
        try {
            const dailies = await fetch(`https://thj20r4htl.execute-api.us-east-1.amazonaws.com/prod/tasks?param=currency`, 
                {
                    method: "GET",
                    headers: {
                        'content-type': "application/json"
                    }
                }
            )
            const data = await dailies.json();
            console.log("data", data)
            setCurrencies(data)
        } catch (error) {

        }
    }

    const processPurchase = async (cost, item) => {
        try {
            const dailies = await fetch(`https://thj20r4htl.execute-api.us-east-1.amazonaws.com/prod/tasks`, 
                {
                    method: "PUT",
                    headers: {
                        'content-type': "application/json"
                    },
                    body: JSON.stringify({
                        ...item,
                        value: item.value - cost
                        
                    })
                }
            )
            getCurrencies();
        } catch (error) {

        }
    }

    return (
        <div>
            <div className="header">
                <button className="nav-button" onClick={() => navigate("/")}>Tasks</button>
                <button className="nav-button" onClick={() => navigate("/security")}>⚡ Security</button>
                <button className="nav-button" onClick={() => navigate("/shop")}>Shop</button>
                <button className="nav-button" onClick={() => navigate("/X")}>X</button>
            </div>
            <div className="values">
                {currencies.length >= 3 && (
                    <>
                        <h1 className="currency1">
                            {currencies[0].sort_key === "one" ? currencies[0].value : currencies[1].sort_key === "one" ? currencies[1].value : currencies[2].sort_key === "one" ? currencies[2].value : currencies[3].value}
                        </h1>
                        <h1 className="currency2">
                            {currencies[0].sort_key === "two" ? currencies[0].value : currencies[1].sort_key === "two" ? currencies[1].value : currencies[2].sort_key === "two" ? currencies[2].value : currencies[3].value}
                        </h1>
                        <h1 className="currency3">
                            {currencies[0].sort_key === "three" ? currencies[0].value : currencies[1].sort_key === "three" ? currencies[1].value : currencies[2].sort_key === "three" ? currencies[2].value : currencies[3].value}
                        </h1>
                        <h1 className="currency4">
                            {currencies[0].sort_key === "four" ? currencies[0].value : currencies[1].sort_key === "four" ? currencies[1].value : currencies[2].sort_key === "four" ? currencies[2].value : currencies[3].value}
                        </h1>
                    </>
                )}
            </div>
            <div className="items1">
                {
                    shopItems1.map((item) => (
                        <div className="item1-card"> 
                            <h1 className="card1-name">{item.name}</h1>
                            <button className="card1-cost" onClick={() => {
                                const currencyItem = currencies[0].sort_key === "one" ? currencies[0] : currencies[1].sort_key === "one" ? currencies[1] : currencies[2].sort_key === "one" ? currencies[2] : currencies[3];
                                processPurchase(item.cost, currencyItem);
                            }}>{item.cost}</button>
                        </div>
                    ))
                }
            </div>
            <div className="items2">
                {
                    shopItems2.map((item) => (
                        <div className="item2-card"> 
                            <h1 className="card2-name">{item.name}</h1>
                            <button className="card2-cost" onClick={() => {
                                const currencyItem = currencies[0].sort_key === "two" ? currencies[0] : currencies[1].sort_key === "two" ? currencies[1] : currencies[2].sort_key === "two" ? currencies[2] : currencies[3];
                                processPurchase(item.cost, currencyItem);
                            }}>{item.cost}</button>
                        </div>
                    ))
                }
            </div>
            <div className="items3">
                {
                    shopItems2.map((item) => (
                        <div className="item3-card"> 
                            <h1 className="card3-name">{item.name}</h1>
                            <button className="card3-cost" onClick={() => {
                                const currencyItem = currencies[0].sort_key === "thee" ? currencies[0] : currencies[1].sort_key === "three" ? currencies[1] : currencies[2].sort_key === "three" ? currencies[2] : currencies[3];
                                processPurchase(item.cost, currencyItem);
                            }}>{item.cost}</button>
                        </div>
                    ))
                }
            </div>
            <div className="items4">
                {
                    shopItems2.map((item) => (
                        <div className="item4-card"> 
                            <h1 className="card4-name">{item.name}</h1>
                            <button className="card4-cost" onClick={() => {
                                const currencyItem = currencies[0].sort_key === "four" ? currencies[0] : currencies[1].sort_key === "four" ? currencies[1] : currencies[2].sort_key === "four" ? currencies[2] : currencies[3];
                                processPurchase(item.cost, currencyItem);
                            }}>{item.cost}</button>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
export default Shop;